
import {
  Vue, Component, Mixins,
} from 'vue-property-decorator';
import AttachmentsList from '@/components/AttachmentsList.vue';
import TaskStatusAlert from '@/components/TaskStatusAlert.vue';
import TaskActions from '@/components/TaskActions.vue';
import TaskActivityBox from '@/components/TaskActivityBox.vue';
import {
  BoxStatusType, AttachmentType,
} from '@/types';
import SwitchWithConfirm from '@/components/SwitchWithConfirm.vue';
import {
  getLeadCustomValueBoolean,
  getLeadCustomValueText,
} from '@/helpers';
import TaskMixin from '@/mixins/TaskMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

@Component({
  components: {
    AttachmentsList,
    TaskStatusAlert,
    TaskActions,
    TaskActivityBox,
    SwitchWithConfirm,
  },
})
export default class TaskA extends Mixins(TaskMixin, UtilsMixin) {
  extraCosti = false

  confUrbCat: BoxStatusType = 'todo'
  modOutFattEner: BoxStatusType = 'todo'
  apePre: BoxStatusType = 'todo'
  apePostSimul: BoxStatusType = 'todo'

  complianceOptions = [
    {
      text: 'Conforme',
      value: 'yes',
    },
    {
      text: 'Non conforme',
      value: 'no',
    },
    {
      text: 'Non conforme, possibile proseguire con DL Semplificazioni',
      value: 'dl',
    },
  ]

  yesnoTypes = [
    {
      text: 'Sì',
      value: true,
    },
    {
      text: 'No',
      value: false,
    },
  ]

  confUrbCatCompliance: string | null | undefined = null
  confUrbCatDisp: boolean | null = null
  confUrbCatDispCustomer: boolean | null = null

  confUrbCatNotes: string | null | undefined = null
  modOutFattEnerNotes: string | null | undefined = null
  apePreNotes: string | null | undefined = null
  apePostSimulNotes: string | null | undefined = null

  siteInspectionResultNotes: string | null | undefined = null

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.extraCosti = this.selectedTask?.extraCosti ?? false;

    this.confUrbCat = (getLeadCustomValueText(this.selectedLead, 'confUrbCat') ?? 'todo') as BoxStatusType;
    this.modOutFattEner = (getLeadCustomValueText(this.selectedLead, 'modOutFattEner') ?? 'todo') as BoxStatusType;
    this.apePre = (getLeadCustomValueText(this.selectedLead, 'apePre') ?? 'todo') as BoxStatusType;
    this.apePostSimul = (getLeadCustomValueText(this.selectedLead, 'apePostSimul') ?? 'todo') as BoxStatusType;

    this.confUrbCatCompliance = getLeadCustomValueText(this.selectedLead, 'confUrbCatCompliance');
    this.confUrbCatDisp = getLeadCustomValueBoolean(this.selectedLead, 'confUrbCatDisp') ?? false;
    this.confUrbCatDispCustomer = getLeadCustomValueBoolean(this.selectedLead, 'confUrbCatDispCustomer') ?? false;

    this.confUrbCatNotes = getLeadCustomValueText(this.selectedLead, 'confUrbCatNotes');
    this.modOutFattEnerNotes = getLeadCustomValueText(this.selectedLead, 'modOutFattEnerNotes');
    this.apePreNotes = getLeadCustomValueText(this.selectedLead, 'apePreNotes');
    this.apePostSimulNotes = getLeadCustomValueText(this.selectedLead, 'apePostSimulNotes');

    this.siteInspectionResultNotes = getLeadCustomValueText(this.selectedLead, 'siteInspectionResultNotes');

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  // I dati extra sono validi?
  get isExtraDataValid(): boolean {
    // Se è impossibile completare il task, i dati extra sono ignorati
    // FIXME: Rimuovere quando questo Task userà il mixin TaskMixin
    if (this.selectedStatus === 'error') return true;

    // La versione 1 dei task non supporta le attività, considera solo gli allegati.

    // Sa la versione del task è 1...
    if (this.taskVersion === 1) {
      // ... il Task non supporta le attività, considera solo gli allegati.

      // Se sono previsti interventi extra? Richiede che sia caricato un ulteriore allegato
      return this.extraCosti
        ? this.hasAttachments('esitoSopralluogoTecnico') && this.hasAttachments('extraSopralluogoTecnico')
        : this.hasAttachments('esitoSopralluogoTecnico');
    }

    // Sa la versione del task è 2...
    if (this.taskVersion === 2) {
      // ... per determinate categorie (24, 15) considera le attività

      if (this.hasCategory(24)) {
        // Le attività sono da fare o in attesa
        if (this.confUrbCat === 'todo' || this.confUrbCat === 'waiting') return false;

        // Le attività sono completate ma manca l'allegato
        if (this.confUrbCat === 'done' && !this.hasAttachments('confUrbCat')) return false;
      }

      if (this.hasCategory(15)) {
        // Le attività sono da fare o in attesa
        if (this.modOutFattEner === 'todo' || this.modOutFattEner === 'waiting') return false;
        if (this.apePre === 'todo' || this.apePre === 'waiting') return false;
        if (this.apePostSimul === 'todo' || this.apePostSimul === 'waiting') return false;

        // Le attività sono completate ma manca l'allegato
        if (this.modOutFattEner === 'done' && !this.hasAttachments('modOutFattEner')) return false;
        if (this.apePre === 'done' && !this.hasAttachments('apePre')) return false;
        if (this.apePostSimul === 'done' && !this.hasAttachments('apePostSimul')) return false;
      }
    }

    // In tutti gli altri casi...
    return true;
  }

  get flatCategories() {
    return this.selectedLead
      && 'flatCategories' in this.selectedLead
      && typeof this.selectedLead.flatCategories === 'string'
      ? this.selectedLead.flatCategories : null;
  }

  get hasCategories() {
    return this.flatCategories
      && this.flatCategories.length > 2;
  }

  get leadCategories(): number[] {
    return this.hasCategories && this.flatCategories
      ? this.flatCategories.substring(1, this.flatCategories.length - 1).split(':')
        .map((s: string) => Number(s))
      : [];
  }

  get confUrbCatDoneDisabled(): boolean { // Ok
    return !this.confUrbCatCompliance
      || (
        (this.confUrbCatCompliance === 'no' || this.confUrbCatCompliance === 'dl')
        && (this.confUrbCatDisp === null)
      );
  }

  get confUrbCatDoneColor(): string { // Ok
    if (this.taskVersion !== 2 || !this.hasCategory(24)) return 'success';

    if (this.errorOnly) return 'red';
    if (this.extraCosti) return 'orange';

    return 'success';
  }

  get errorOnly(): boolean { // Ok
    if (this.taskVersion === 2
      && this.hasCategory(24)
      && this.confUrbCatCompliance !== 'yes'
      && this.confUrbCat === 'done') {
      return !this.extraCosti;
    }

    return false;
  }

  get errorText(): string { // Ok
    return this.errorOnly ? 'Completa' : 'Impossibile completare?';
  }

  get errorColor(): string {
    if (this.taskVersion !== 2
      || !this.hasCategory(24)
      || this.confUrbCatCompliance !== 'no'
      || (this.confUrbCatCompliance === 'no' && this.confUrbCatDisp === true)
      || this.confUrbCatDisp === null) {
      return 'red';
    }

    return this.confUrbCatDoneColor;
  }

  get completeColor(): string {
    if (this.taskVersion !== 2 || !this.hasCategory(24)) return 'success';

    if (this.confUrbCatCompliance === 'yes') return 'success';
    if (this.confUrbCatCompliance === 'no' || this.confUrbCatCompliance === 'dl') return this.confUrbCatDoneColor;

    return 'success';
  }

  updateBoxStatus(name: string, status: BoxStatusType) {
    console.log(`${this.constructor.name}: updateBoxStatus(${name}, ${status})`); // eslint-disable-line no-console

    // Se lo stato non esiste si ferma subito
    if (name in this === false) { return; }

    this[name] = status;

    const update = {} as { [key: string]: unknown };

    update[name] = status;

    this.$store.dispatch('updateTaskFields', update);
  }

  hasCategory(id: number) { return this.leadCategories.findIndex((c) => c === id) > -1; }

  hasAttachments(fieldname: AttachmentType): boolean {
    return this.attachments.filter((a) => a.fieldname === fieldname).length > 0;
  }

  onExtraCostiChange() {
    console.log(`${this.constructor.name}: onExtraCostiChange()`); // eslint-disable-line no-console

    const update = {} as { [key: string]: unknown };

    update.extraCosti = this.extraCosti;

    this.$store.dispatch('updateTaskFields', update);
  }

  onFieldUpdated(field: string) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    const update = {} as { [key: string]: unknown };

    // Aggiorna sempre il campo specificato
    update[field] = this[field] ?? '';

    // Aggiorna eventuali campi collegati, eccezioni, ecc.
    switch (field) {
      case 'confUrbCatCompliance':
        update.confUrbCatCompliance = this.confUrbCatCompliance ?? null;

        // Conforme -> Imposta il box su FATTO
        if (this.confUrbCatCompliance === 'yes') {
          this.confUrbCat = 'done';
          update.confUrbCat = 'done';
        }

        // Ogni modifica alla conformità azzera la select per la disponibilità
        this.confUrbCatDisp = null;
        update.confUrbCatDisp = null;
        this.confUrbCatDispCustomer = null;
        update.confUrbCatDispCustomer = null;

        // Ogni modifica alla conformità azzera l'extraCosti
        this.extraCosti = false;
        update.extraCosti = false;
        break;

      case 'confUrbCatDisp':
        update.confUrbCatDisp = this.confUrbCatDisp ?? null;

        if (this.confUrbCatDisp === true) {
          // Non conforme; Sì; ? -> ROSSO
          if (this.confUrbCatCompliance === 'no') {
            this.extraCosti = false;
            update.extraCosti = false;
          }
          // Non conforme + DL; Sì; ? -> GIALLO
          if (this.confUrbCatCompliance === 'dl') {
            this.extraCosti = true;
            update.extraCosti = true;
          }
          this.confUrbCat = 'done';
          update.confUrbCat = 'done';
        } // eslint-disable-line brace-style

        else if (this.confUrbCatDisp === false) {
          // Non conforme; No; ? -> ROSSO
          if (this.confUrbCatCompliance === 'no') {
            this.extraCosti = false;
            update.extraCosti = false;
          }
          // Non conforme + DL; No; ? -> GIALLO
          if (this.confUrbCatCompliance === 'dl') {
            this.extraCosti = true;
            update.extraCosti = true;
          }
          this.confUrbCat = 'done';
          update.confUrbCat = 'done';
        } // eslint-disable-line brace-style

        else {
          // Non conforme; ?; ? -> Da fare
          // Non conforme + DL; ?; ? -> Da fare
          this.extraCosti = false;
          update.extraCosti = false;
          this.confUrbCat = 'todo';
          update.confUrbCat = 'todo';
        }

        // Ogni modifica alla disponibilità azzera la select per la disponibilità
        // del cliente
        this.confUrbCatDispCustomer = null;
        update.confUrbCatDispCustomer = null;

        break;

      case 'confUrbCatDispCustomer':
        // update.confUrbCatDispCustomer diventa null in caso di clear
        update.confUrbCatDispCustomer = this.confUrbCatDispCustomer ?? null;

        // Sì
        if (update.confUrbCatDispCustomer === true) {
          // Non conforme; No; Sì -> GIALLO
          // Non conforme; Sì; Sì -> Giallo
          // Non conforme + DL; No; Sì -> GIALLO
          // Non conforme + DL; Sì; Sì -> Giallo
          this.extraCosti = true;
          update.extraCosti = true;
        } // eslint-disable-line brace-style

        // No
        else if (update.confUrbCatDispCustomer === false) {
          // Non conforme; No; No -> ROSSO
          // Non conforme; Sì; No -> Rosso
          if (this.confUrbCatCompliance === 'no') {
            this.extraCosti = false;
            update.extraCosti = false;
          }
          // Non conforme + DL; No; No -> GIALLO
          // Non conforme + DL; Sì; No -> Giallo
          if (this.confUrbCatCompliance === 'dl') {
            this.extraCosti = true;
            update.extraCosti = true;
          }
        } // eslint-disable-line brace-style

        // Vuoto
        else if (update.confUrbCatDispCustomer === null) {
          // Non conforme; No; ? -> ROSSO
          // Non conforme; Sì; ? -> ROSSO
          if (this.confUrbCatCompliance === 'no') {
            this.extraCosti = false;
            update.extraCosti = false;
          }
          // Non conforme + DL; No; ? -> GIALLO
          // Non conforme + DL; Sì; ? -> GIALLO
          if (this.confUrbCatCompliance === 'dl') {
            this.extraCosti = true;
            update.extraCosti = true;
          }
        }

        this.confUrbCat = 'done';
        update.confUrbCat = 'done';

        break;

      // In tuti gli altri casi...
      default:
        // ...  aggiorna il campo specificato.
        update[field] = this[field] ?? '';
        break;
    }

    this.$store.dispatch('updateTaskFields', update);
  }

  // Effetta la validazione del modulo
  async onValidate(status: 'completed' | 'error') {
    console.log(`${this.constructor.name}: onValidate(${status})`); // eslint-disable-line no-console

    // Sceglie se validare il modulo per un completamento o per un fallimento
    this.selectedStatus = status;

    // Avvia l'effettiva validazione
    const form = this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };

    if (form) {
      const result = form.validate();
      console.log(`${this.constructor.name}: onValidate() form.validate() =`, result); // eslint-disable-line no-console
    } else {
      console.error(`${this.constructor.name}: onValidate() form =`, form); // eslint-disable-line no-console
      console.error(`${this.constructor.name}: onValidate() this.$refs =`, this.$refs); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }
}
